import { api } from './client';
import type { VerificationStatus } from '@/types/domain';

export async function fetchVerificationStatus(): Promise<{
  status: VerificationStatus;
  rejected_reason?: string;
}> {
  return api.get('/verification/status/');
}

export async function submitVerification(passport: File, selfie: File): Promise<void> {
  const fd = new FormData();
  fd.append('passport', passport);
  fd.append('selfie', selfie);
  await api.post('/verification/submit/', { body: fd });
}
